"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useRef, useState } from "react";
import { Badge, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useRouter } from "next/navigation";
import MaxWidth from "@/app/(main_app)/_components/MaxWidth";
import BottomSheet from "@/components/ui/BottomSheet";
import useSheetHash from "@/lib/hooks/useSheetHash";
import { useContractorFiltersStore } from "@/store/store";
import FilterSheet from "./FilterSheet";
import { useContractorsQuery } from "../_provider/ContractorsQueryProvider";
import { useSurveySheetStore } from "@/store/surveySheetStore";
import { useDebounce } from "../_hooks/useDebounce";
import { inhomzEvents } from "../../../_lib/events";
import { useInhomzTrack } from "../../../_hooks/useInhomzTrack";
export default function ContractorsListHeader() {
  const $ = _c(43);
  const router = useRouter();
  const track = useInhomzTrack();
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [showFilterSheet, setShowFilterSheet] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setShowFilterSheet(false);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useSheetHash(showFilterSheet, "#filters", t0);
  const {
    appliedFilters
  } = useContractorFiltersStore();
  const {
    searchQuery,
    setSearchQuery
  } = useContractorsQuery();
  const openSurvey = useSurveySheetStore(_temp);
  let t1;
  if ($[1] !== appliedFilters.selected) {
    t1 = Object.values(appliedFilters.selected).reduce(_temp2, 0);
    $[1] = appliedFilters.selected;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const activeFilterCount = t1;
  const debouncedSearch = useDebounce(searchQuery, 800);
  const lastTrackedSearch = useRef("");
  let t2;
  if ($[3] !== debouncedSearch || $[4] !== track) {
    t2 = () => {
      const term = debouncedSearch.trim();
      if (term.length < 2 || term === lastTrackedSearch.current) {
        return;
      }
      lastTrackedSearch.current = term;
      track(inhomzEvents.contractors.SEARCH_PERFORMED, {
        event_value: term
      });
    };
    $[3] = debouncedSearch;
    $[4] = track;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t2);
  let t3;
  if ($[6] !== router || $[7] !== track) {
    t3 = () => {
      track(inhomzEvents.contractors.BACK_CLICKED);
      router.push("/");
    };
    $[6] = router;
    $[7] = track;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleBack = t3;
  let t4;
  if ($[9] !== track) {
    t4 = () => {
      track(inhomzEvents.contractors.SEARCH_CLICKED);
      setIsSearchActive(true);
    };
    $[9] = track;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleSearchClick = t4;
  let t5;
  if ($[11] !== setSearchQuery) {
    t5 = () => {
      lastTrackedSearch.current = "";
      setIsSearchActive(false);
      setSearchQuery("");
    };
    $[11] = setSearchQuery;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleCloseSearch = t5;
  let t6;
  if ($[13] !== openSurvey || $[14] !== track) {
    t6 = () => {
      track(inhomzEvents.contractors.SURVEY_CLICKED, {
        placement: "header"
      });
      openSurvey();
    };
    $[13] = openSurvey;
    $[14] = track;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const handleTakeSurveyClick = t6;
  let t7;
  if ($[16] !== activeFilterCount || $[17] !== track) {
    t7 = () => {
      track(inhomzEvents.contractors.FILTER_CLICKED, {
        filters_count: activeFilterCount
      });
      setShowFilterSheet(true);
    };
    $[16] = activeFilterCount;
    $[17] = track;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleFilterClick = t7;
  let t8;
  if ($[19] !== handleBack || $[20] !== isSearchActive) {
    t8 = !isSearchActive && <IconButton onClick={handleBack} aria-label="Go back" sx={{
      color: "var(--textPrimaryPrimary)"
    }}><ArrowBackIcon /></IconButton>;
    $[19] = handleBack;
    $[20] = isSearchActive;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== activeFilterCount || $[23] !== handleCloseSearch || $[24] !== handleFilterClick || $[25] !== handleSearchClick || $[26] !== handleTakeSurveyClick || $[27] !== isSearchActive || $[28] !== searchQuery || $[29] !== setSearchQuery) {
    t9 = !isSearchActive ? <div className="flex items-center gap-1"><IconButton onClick={handleTakeSurveyClick} aria-label="Take survey" sx={{
        color: "var(--textPrimaryPrimary)"
      }}><AssignmentOutlinedIcon /></IconButton><IconButton onClick={handleFilterClick} aria-label="Filter professionals" className="lg:!hidden" sx={{
        color: "var(--textPrimaryPrimary)"
      }}><Badge badgeContent={activeFilterCount} sx={{
          "& .MuiBadge-badge": {
            backgroundColor: "var(--colorErrorError)",
            color: "var(--textPrimaryOnColorPrimary)"
          }
        }}><FilterListOutlinedIcon /></Badge></IconButton><IconButton onClick={handleSearchClick} aria-label="Search professionals" sx={{
        color: "var(--textPrimaryPrimary)"
      }}><SearchOutlinedIcon /></IconButton></div> : <div className="flex-1 flex items-center gap-2 mx-2"><IconButton onClick={handleCloseSearch} className="flex-shrink-0" aria-label="Close search" sx={{
        color: "var(--textPrimaryPrimary)"
      }}><SearchOutlinedIcon /></IconButton><input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search by contractor name" autoFocus={true} className="flex-1 h-10 bg-[--colorSurfaceSurface] outline-none placeholder:text-[--textSecondarySecondary] text-[--textPrimaryPrimary]" style={{
        fontFamily: "Manrope",
        fontSize: "16px"
      }} /><IconButton onClick={handleCloseSearch} className="flex-shrink-0" aria-label="Close search" sx={{
        color: "var(--textPrimaryPrimary)"
      }}><CloseIcon /></IconButton></div>;
    $[22] = activeFilterCount;
    $[23] = handleCloseSearch;
    $[24] = handleFilterClick;
    $[25] = handleSearchClick;
    $[26] = handleTakeSurveyClick;
    $[27] = isSearchActive;
    $[28] = searchQuery;
    $[29] = setSearchQuery;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t8 || $[32] !== t9) {
    t10 = <header className="sticky top-0 z-10 bg-[--colorSurfaceSurface]"><MaxWidth padding="px-2 py-2 md:px-4 md:py-3"><div className="flex items-center justify-between">{t8}{t9}</div></MaxWidth></header>;
    $[31] = t8;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setShowFilterSheet(false);
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== showFilterSheet) {
    t12 = showFilterSheet && <FilterSheet onClose={() => setShowFilterSheet(false)} />;
    $[35] = showFilterSheet;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== showFilterSheet || $[38] !== t12) {
    t13 = <BottomSheet open={showFilterSheet} onClose={t11} bgColor="var(--colorSurfaceSurface)" maxWidth="430px">{t12}</BottomSheet>;
    $[37] = showFilterSheet;
    $[38] = t12;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t10 || $[41] !== t13) {
    t14 = <>{t10}{t13}</>;
    $[40] = t10;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  return t14;
}
function _temp2(total, selectedValues) {
  return total + (selectedValues?.length || 0);
}
function _temp(state) {
  return state.open;
}